import Page403 from 'components/Page403'
import Page404 from 'components/Page404'
import Spinner from 'components/Spinner'
import { useProfile } from 'context/ProfileProvider'
import { useModules } from 'hooks/modules'
import type { ReactNode } from 'react'
import type { PermissionCode } from 'shared/permissions'
import type { Module } from 'shared/types'

interface PrivateRouteProps {
  permissions?: PermissionCode[]
  modules?: Module['slug'][]
  children: ReactNode
}

function PrivateRoute({ permissions = [], modules = [], children }: PrivateRouteProps) {
  const { profile, hasPermission } = useProfile()
  const { enabledModules, isLoading } = useModules()

  function hasPermissions() {
    if (!permissions.length) return true
    return permissions.some(permission => hasPermission(permission))
  }

  function hasModules() {
    if (!modules.length) return true
    return modules.some(module => enabledModules.some(enabledModule => enabledModule.slug === module))
  }

  // Permissions are not fetched yet
  if (!profile?.permissions || (modules.length > 0 && isLoading)) return <Spinner />

  // Modules KO: 404
  if (!hasModules()) return <Page404 />

  // Permissions OK
  if (hasPermissions()) return children

  // No permissions: 403
  return <Page403 />
}

export default PrivateRoute
